import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"mobile-btn",class:{plain: _vm.plain},attrs:{"disabled":_vm.disabled,"href":_vm.href,"width":"100%","depressed":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"mobile-btn-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }